import { IObservable, Subject } from '~/rage/utils';
import { IContact } from '~/shared';
import { IContactsService } from './contactsServiceTypes';

const initialContacts: IContact[] = [
	{ phoneNumber: '5550101', name: 'stdian', isFavorite: true },
	{ phoneNumber: '5550000', name: 'Artem Bakhia', isFavorite: false },
];

export class ContactsServiceStub implements IContactsService {
	private readonly contacts = new Subject<IContact[]>([...initialContacts]);

	getContacts(): IObservable<IContact[]> {
		return this.contacts;
	}

	async addContact(phoneNumber: string, name: string): Promise<void> {
		const list = this.contacts.getValue();
		if (list.some((c) => c.phoneNumber === phoneNumber)) {
			return;
		}
		this.contacts.next([...list, { phoneNumber, name, isFavorite: false }]);
	}

	async removeContact(phoneNumber: string): Promise<void> {
		const list = this.contacts
			.getValue()
			.filter((c) => c.phoneNumber !== phoneNumber);
		this.contacts.next(list);
	}

	async toggleFavorite(phoneNumber: string): Promise<void> {
		const list = this.contacts
			.getValue()
			.map((c) =>
				c.phoneNumber === phoneNumber ? { ...c, isFavorite: !c.isFavorite } : c,
			);
		this.contacts.next(list);
	}
}
